import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	hostProfile: null,
};

const hostProfileSlice = createSlice({
	name: "hostProfile",
	initialState,
	reducers: {
		setHostProfile: (state, action) => {
			state.hostProfile = action.payload;
		},
	},
});

export const { setHostProfile } = hostProfileSlice.actions;

export default hostProfileSlice.reducer;
